import React, { useState } from "react"
import * as Adm from "@adm"
import { AppContext } from "@utils"
import * as IconsGallery from "@iconsGallery"

const LABEL_TO_COUNTRY_CODE = {
  USA: "US",
  UAE: "AE",
  India: "IN",
}

const COUNTRY_CODE_TO_LABEL = {
  US: "USA",
  AE: "UAE",
  IN: "India",
}

function getInitialRegionLabel() {
  const storedCountryCode = `${localStorage.getItem("country_code") || ""}`.trim()
  const storedCountryName = `${
    localStorage.getItem("country_selected") || ""
  }`.trim()
  return (
    COUNTRY_CODE_TO_LABEL[storedCountryCode] ||
    storedCountryName ||
    storedCountryCode ||
    "USA"
  )
}

export default function TenantRegionDropdown() {
  const { getGlobalCountryList = [] } = React.useContext(AppContext)
  const [getRegionLabel, setRegionLabel] = useState(getInitialRegionLabel)
  const getRegionList = getGlobalCountryList?.map((itm) => {
    return itm?.name
  })

  React.useEffect(() => {
    const syncLabel = () => setRegionLabel(getInitialRegionLabel())
    window.addEventListener("dg-country-code-change", syncLabel)
    return () => window.removeEventListener("dg-country-code-change", syncLabel)
  }, [])

  const onHandleChange = (nextLabel) => {
    const matchedCountry = (getGlobalCountryList || []).find(
      (itm) => itm?.name === nextLabel
    )
    const nextCountryCode =
      matchedCountry?.phoneCode || LABEL_TO_COUNTRY_CODE[nextLabel]
    if (!nextCountryCode) return
    setRegionLabel(nextLabel)

    const _regionItem =
      matchedCountry ||
      (getGlobalCountryList || []).find(
        (itm) => itm.phoneCode === nextCountryCode
      ) ||
      {}

    localStorage.setItem("country_selected", _regionItem?.name || nextLabel)
    localStorage.setItem("country_code", nextCountryCode)
    if (_regionItem?.currency?.[0]) {
      localStorage.setItem(
        "currencyType",
        JSON.stringify(_regionItem.currency[0])
      )
    }
    window.dispatchEvent(
      new CustomEvent("dg-country-code-change", {
        detail: { countryCode: nextCountryCode, countryName: nextLabel },
      })
    )

    /* eslint-disable no-restricted-globals */
    let defaultPage = window.location.href

    if (location.href.includes("dashboard?page=autonomous&retailer=")) {
      defaultPage = location.origin + "/master/dashboard"
    }

    if (
      window.location.href.includes("master/alert/configuration/") &&
      window.location.pathname.split("/").length >= 5
    ) {
      defaultPage =
        window.location.origin +
        window.location.pathname
          .split("/")
          .slice(0, location.pathname.split("/").length === 6 ? -2 : -1)
          .join("/")
    }
    if (
      window.location.href.includes("master/alert/monitor/") &&
      window.location.pathname.split("/").length >= 5
    ) {
      defaultPage =
        window.location.origin +
        window.location.pathname
          .split("/")
          .slice(0, location.pathname.split("/").length === 6 ? -2 : -1)
          .join("/")
    }

    if (
      window.location.href.includes("master/Transactions/") &&
      window.location.pathname.split("/").length >= 5
    ) {
      defaultPage =
        window.location.origin +
        window.location.pathname
          .split("/")
          .slice(0, window.location.pathname.split("/").length === 6 ? -2 : -1)
          .join("/") +
        "?filter=false"

      localStorage.removeItem("defaultRealmIdSelect")

      localStorage.setItem(
        "defaultSaasValueState",
        JSON.stringify({
          dataState: {
            filter: {
              logic: "and",
              filters: [{ field: "name", operator: "contains", value: "" }],
            },
            sort: [],
            skip: 0,
            take: 50,
          },
        })
      )
    }
    /* eslint-disable no-restricted-globals */
    window.location.href = defaultPage
    // window.location.href = window.location.href
  }

  // console.log(
  //   "getGlobalCountryList",
  //   getGlobalCountryList,
  //   getRegionList,
  //   TENANT_REGIONS
  // )
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{ marginRight: 8, fontWeight: "bold", color: "#2e2e2e" }}
      >{`Tenant Region: `}</div>
      <div className="tenant-region-dropdown">
        <Adm.DropdownKit
          idAddOn="-tenantRegion"
          classes={{ height: 40, borderRadius: "22px" }}
          name="tenantRegion"
          icons={
            getGlobalCountryList
              ? getGlobalCountryList?.map((itm) => {
                  return () => (
                    <span
                      style={{
                        width: 20,
                        height: 20,
                        marginRight: 15,
                        borderRadius: 22,
                      }}
                    >
                      <img
                        style={{
                          transform: "scale(1.2)",
                          width: 20,
                          height: 20,
                          borderRadius: 30,
                          overflow: "hidden",
                        }}
                        alt={`phonecode_${itm?.phoneCode?.toLocaleLowerCase()}`}
                        src={`https://flagcdn.com/w80/${itm?.phoneCode?.toLocaleLowerCase()}.png`}
                      />
                    </span>
                  )
                })
              : []
          }
          list={getRegionList}
          defaultValue={getRegionLabel}
          onUpdate={onHandleChange}
          placeholder=""
          style={{
            minWidth: 110,
            height: 40,
            background: "#F2F2F2",
            borderRadius: "22px",
          }}
          selectPropsKit={{
            sx: {
              "& .MuiOutlinedInput-root": {
                borderRadius: "22px",
              },
            },
            MenuProps: {
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              PaperProps: {
                style: {
                  borderRadius: "12px",
                  marginTop: "6px",
                  backgroundColor: "#f0f6ff",
                  padding: 6,
                },
              },
            },
          }}
        />
      </div>
    </div>
  )
}
